<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
{{ 'bikeshop.menu.service_imports' | translate }}
</span>
    </div>
  </div>

  <div class="flex">
    <div class="wizard">
      <ul>
        <li>
          <a class="first">
            <span class="wizard-step" [ngClass]="{'active': step===1, 'complete' : step > 1}">
              <span [ngClass]="{'inner-circle':step === 1}"></span>
              <span [ngClass]="{'hide':step > 1}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===1, 'complete' : step > 1}">{{
              'bikeshop.service_imports.step1' | translate}}</span>
          </a>
        </li>
        <li>
          <a>
            <span class="wizard-step" [ngClass]="{'active': step===2, 'complete' : step > 2}">
              <span [ngClass]="{'inner-circle':step === 2}"></span>
              <span [ngClass]="{'hide':step > 2}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===2, 'complete' : step > 2}">{{
              'bikeshop.service_imports.step2' | translate}}</span>
          </a>
        </li>
        <li class="last">
          <a>
            <span class="wizard-step" [ngClass]="{'active': step===3}">
              <span [ngClass]="{'inner-circle':step === 3}"></span>
              <span [ngClass]="{'hide':step > 3}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===3, 'complete' : step > 2}">{{
              'bikeshop.service_imports.step3' | translate}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div *ngIf="invalidFileFormat"
       class="validation-issues">{{ "bikeshop.service_imports.invalid_file_format" | translate }}</div>
  <div class="margin-top-16 content download-container" *ngIf="step === 1">
    <div>
      <div>
        <a href="/assets/excel-templates/Job Import Template.xlsx" target="_blank"
           download="Job Import Template.xlsx">
          <button class="iso-round-button full-width"
          >{{ 'bikeshop.service_imports.download_template' | translate }}</button>
        </a>
      </div>
      <div class="margin-top-16">
        <button class="iso-round-button full-width iso-light"
                (click)="fileUpload.click()">{{ 'bikeshop.service_imports.select_file' | translate }}</button>
        <input #fileUpload type="file" accept=".xlsx" style="display: none;" (change)="prepareFile($event)">
      </div>
    </div>
  </div>

  <div class="content margin-top-16 margin-bottom-16" *ngIf="step == 2">
    <div class="validation-issues" *ngIf="hasValidationErrors">
      {{ 'bikeshop.service_imports.has_validation_errors' | translate }}
    </div>

    <p-table #servicesTable [columns]="columns" [value]="data">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''"
              [ngStyle]="{'width': col.field === 'Notes' ? '250px' : 'auto'}">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-service let-columns="columns">
        <tr [pSelectableRow]="service">
          <td *ngFor="let col of columns" [ngClass]="{ 'invalid-row' : service['Status'] !== 'Valid' }">
            <div>
              <ul *ngIf="col.type === 'status' && service[col.field] !== 'Valid'"
                  [innerHTML]="service[col.field]"
                  class="invalid"></ul>
            </div>
            <div>
              <ul *ngIf="col.type === 'bikeSummary'" [innerHTML]="service[col.field]"
                  class="bike-summary"></ul>
            </div>
            <div *ngIf="col.type === 'notes'">
              <ul [innerHTML]="service[col.field]" class="bike-summary"></ul>
            </div>
            <div>
              <ul *ngIf="col.type === 'dateSummary'" [innerHTML]="service[col.field]"
                  class="date-summary"></ul>
            </div>
            <div *ngIf="col.type === 'status' && service[col.field] === 'Valid'">
              <span class="fa fa-check-square-o"></span>
            </div>
            <div
              *ngIf="col.type !== 'status' && col.type !== 'bikeSummary' && col.type !== 'dateSummary' && col.type !== 'notes'">
              {{
              col.type === "date" && service[col.field].length < 20 && service[col.field] !== '-'
                ? (service[col.field] | date) :
                service[col.field]
              }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="content margin-top-16 margin-bottom-16" *ngIf="step == 3">

    <div class="margin-bottom-16">
      <p-progressBar [value]="progress"></p-progressBar>
    </div>

    <p-table #servicesTable [columns]="columnsImported" [value]="importData">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-service let-columns="columns">
        <tr [pSelectableRow]="service">
          <td *ngFor="let col of columns" [ngClass]="{ 'invalid-row' : service['Status'] !== 'Valid' }"
              [ngStyle]="{'width': col.field === 'Notes' ? '250px' : 'auto'}">
            <div *ngIf="col.type === 'status' && service[col.field] === null">
              <span class="fa fa-spinner fa-pulse"></span>
            </div>
            <div *ngIf="col.type === 'status' && service[col.field] === 'Imported'">
              <span class="fa fa-check-square-o"></span>
            </div>
            <div *ngIf="col.type === 'status' && service[col.field] !== null && service[col.field] !== 'Imported'">
              <ul [innerHTML]="service[col.field] | translate" class="invalid"></ul>
            </div>
            <div *ngIf="col.type === 'bikeSummary'">
              <ul [innerHTML]="service[col.field]" class="bike-summary"></ul>
            </div>
            <div *ngIf="col.type === 'notes'">
              <ul [innerHTML]="service[col.field]" class="bike-summary"></ul>
            </div>
            <div *ngIf="col.type !== 'status' && col.type !== 'bikeSummary' && col.type !== 'notes'">
              {{
              col.type === "date" && (service[col.field] !== null || service[col.field] !== undefined) ? (service[col.field] | date : 'medium') :
                service[col.field]
              }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</div>

<div class="bottom-sheet" *ngIf="step == 2">
  <div class="flex">

    <div style="flex:1">
      <div class="row" *ngIf="needsBookingStartDate">
        <div class="col-md-3 label" [ngClass]="{'red' : needsBookingStartDate && startDate === null }">
          *{{ 'bikeshop.service_imports.select_start_date' | translate }}</div>
        <div class="col-md-2 value">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="fa fa-calendar-check-o"></i></span>
            <p-calendar [(ngModel)]="startDate" dateFormat="{{countryData.DatePickerFormat}}"></p-calendar>
          </div>
        </div>
        <div class="col-md-6 flex">
          <small>{{ "bikeshop.service_imports.select_start_date_info" | translate }}</small>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 label">{{ 'bikeshop.service_imports.send_customer_communication' | translate }}</div>
        <div class="col-md-1 value">
          <p-inputSwitch [(ngModel)]="sendCommunication"></p-inputSwitch>
        </div>
      </div>
      <div class="row" *ngIf="needsForceBookingOption">
        <div class="col-md-3 label">{{ 'bikeshop.service_imports.force_booking_on_day' | translate }}</div>
        <div class="col-md-2 value">
          <p-inputSwitch [(ngModel)]="forceBookingToScheduledDate"></p-inputSwitch>
        </div>
        <div class="col-md-6 flex">
          <small>{{ 'bikeshop.service_imports.force_booking_on_day_info' | translate }}</small>
        </div>
      </div>
    </div>

    <div class="right flex">
      <button class="iso-round-button" (click)="resetWizard()"
      >{{ 'bikeshop.service_imports.reset_wizard' | translate }}</button>
      <div style="min-width: 200px;margin-left: 32px">
        <button class="iso-round-button iso-light" (click)="beginImport()"
                [disabled]="needsBookingStartDate && startDate === null"
        >{{ 'bikeshop.service_imports.begin_import' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="bottom-sheet" *ngIf="step == 3 && !importing">
  <div class="flex">
    <div class="right flex">
      <button class="iso-round-button iso-light" (click)="resetWizard()"
      >{{ 'bikeshop.service_imports.import_another_file' | translate }}</button>
    </div>
  </div>
</div>
